import { render, staticRenderFns } from "./TopGainers.vue?vue&type=template&id=b92beaaa"
import script from "./TopGainers.vue?vue&type=script&lang=js"
export * from "./TopGainers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports